import React from "react";
// import Header from "./Header";
import Linechart from "./charts/Linechart";
import Piechart from "./charts/Piechart";
import Sidebar from "./Sidebar";

export default function Notification(props) {
  return (
    <>
      
      <Sidebar/>
      <div className="tab_content_outer dashboard_outer">
      
        <div className="container">
          <h2 className='page_title'>{props.title}</h2>

          <div className='content'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='cards'>
                  <Piechart/>
                </div>
              </div>

              <div className='col-md-6'>
                <div className='cards'>
                  <Linechart/>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
